/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const MicrophoneIcon = /*#__PURE__*/ createSvgIcon(
  'MicrophoneIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10 12.5a2.411 2.411 0 01-1.77-.73A2.41 2.41 0 017.5 10V5c0-.694.243-1.285.73-1.77A2.41 2.41 0 0110 2.5a2.41 2.41 0 011.77.73A2.41 2.41 0 0112.5 5v5a2.41 2.41 0 01-.73 1.77 2.411 2.411 0 01-1.77.73zm-.75 4.25v-1.313a5.235 5.235 0 01-3.135-1.53 5.34 5.34 0 01-1.553-3.136.646.646 0 01.165-.545.675.675 0 01.52-.226c.21 0 .388.073.534.219.146.146.24.323.281.531.181.958.643 1.74 1.386 2.344A3.92 3.92 0 009.991 14c.964 0 1.818-.306 2.561-.917a3.876 3.876 0 001.385-2.333 1.03 1.03 0 01.277-.531.714.714 0 01.532-.219c.21 0 .386.075.525.226.139.15.194.332.166.545a5.339 5.339 0 01-1.552 3.135 5.234 5.234 0 01-3.135 1.531v1.313c0 .212-.072.39-.214.534a.72.72 0 01-.532.216.734.734 0 01-.535-.216.72.72 0 01-.22-.534zM10 11c.283 0 .52-.096.712-.287A.968.968 0 0011 10V5a.967.967 0 00-.288-.713A.967.967 0 0010 4a.968.968 0 00-.713.287A.968.968 0 009 5v5c0 .283.096.52.287.713.192.191.43.287.713.287z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default MicrophoneIcon;
